import $ from 'jquery';

/**
 * Donation settings
 */
export class Donation23 {

  constructor() {

    const _this = this;

    $('.woocommerce')
      .on('click', '.donation_button', function (e) {
        e.preventDefault();

        const id = $(this)
          .data('product_id');
        const amount = $(this)
          .data('amount');

        _this.send_ajax(amount, id);

      })
    ;

    $('.woocommerce')
      .on('click', '.donation_amount_custom_submit', function (e) {
        e.preventDefault();

        // find the input field with the custom amount
        const input = $('input.donation_amount_custom');
        const id = input.data('product_id');
        const _amount = input.val();

        if (_amount === '') {
          return;
        }

        // Format the number to use a comma as the decimal separator
        const amount = _amount.replace('.', ',');

        _this.send_ajax(amount, id);
      });

    // show the donation popup
    $(document.body)
      .on('click', '.donation_block a.donation_modal', function (e) {
        e.preventDefault();
        $('#donationModal')
          .modal('show');
      })
    ;

    // make custom donation button only clickable if an amount has been filled in
    $(document).ready(function() {
      $('.donation_amount_custom').on('input', function() {
        const $button = $('.donation_amount_custom_submit');
        if ($(this).val().trim() !== "") {
          $button.css({
            'background-color': '#24a89b',
            'color': 'white'
          }).prop('disabled', false);
        } else {
          $button.css({
            'background-color': '#E9EAEC',
            'color': '#A5AAB4'
          }).prop('disabled', true);
        }
      });
    });
  }

  send_ajax(amount, id) {

    const cover = $('.donation_cover');
    $('#cover_message').html('Toevoegen aan winkelwagen...');
    cover.css('z-index', 1000);
    cover.addClass('visible');

    $.ajax({
      //eslint-disable-next-line no-undef
      url:      ajax_link,
      method:   'POST',
      data:     {
        action: 'add_donation_to_cart',
        id:     id,
        amount: amount,
        //eslint-disable-next-line no-undef
        nonce: ajax_nonce,
      },
      dataType: 'json',
      success:  (response) => { // Changed to arrow function
        if (response.success) {
          if ($('.cart').length > 0) {
            window.location.reload();
          } else {

            // Update the WC counter visually
            if( $('.cart-contents-count').length ){
              let cnt = +$('.cart-contents-count').html() + 1;
              $('.cart-contents-count').text(cnt );
            } else {
              $('a.cart-contents').append('<span class="cart-contents-count">1</span>');
            }

            // Update the block
            $('#cover_message').html('Toegevoegd. Dank voor uw donatie!');
            setTimeout(() => {
              this.remove_cover();
            }, 2000);

          }
        } else {
          this.remove_cover();
        }
      },
      error:    () => { // Changed to arrow function
        this.remove_cover();
      }
    });
  }

  remove_cover() {
    $('.donation_cover')
      .removeClass('visible');

    setTimeout(() => {
      $('.donation_cover')
        .css('z-index', '-10');
    }, 1000);

  }

}
